import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { MentionMember } from '@/app/core/Models/Mention';
import { TaskDetail } from '@/app/core/Models/Task';
import { LocalizationViewModel } from '../../ViewModels/localizationViewModel';

@Component({
  selector: 'app-task-description',
  templateUrl: './task-description.component.html',
  styleUrls: ['./task-description.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TaskDescriptionComponent {
  @Input() task: TaskDetail;
  @Input() mentionMembers: MentionMember[] = [];

  localization = this.localiztionViewModel.localization
  constructor(
    private localiztionViewModel: LocalizationViewModel,
    private cdref: ChangeDetectorRef) { }

  detectMention(text: string) {
    if (!text) return '';
    
    let currentText = text;
    this.mentionMembers.forEach((user) => {
      let search = text.search(`@${user.name}`);
      if (search >= 0) {
        currentText = currentText.replace(`@${user.name}`, (mention: any) => {
          return `<span class="mentioned-user">@${user.name}</span>`;
        });
      }
    });
    return currentText;
  }

  detect() {
    this.cdref.detectChanges();
  }

  stripeText(text: string) {
    if (!text) return '';
    return text.replace(/<[^>]*>?/gm, '');
  }

  detectUrls(text: string) {
    if (!text) return '';
    return this.stripeText(text).replace(/(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/g, '<a class="text-primary" target="_blank" rel="nofollow" href="$1">$1</a>')
  }

  get taskBody(): TaskDetail['body'] {
    if (!this.task.body) {
      // If body is null (parsing failed), create a text section with the raw description
      return [{ type: 'text', text: this.detectUrls(this.task.description) }];
    }
    
    return this.task.body.map(section =>
      section.type == 'text'
        ? { ...section, text: this.detectUrls(section.text) }
        : section
    );
  }
  
  // Check if the description is valid JSON format or plain text
  get isJsonDescription(): boolean {
    return this.task.body !== null;
  }
}
